export enum BootstrapIcon {
  PersonCircle = 'person-circle',
  SortUp = 'sort-up',
  SortDown = 'sort-down',
  InfoCircle = 'info-circle',
  Search = 'search',
  EmojiSmile = 'emoji-smile',
}

export function getBootstrapIconUrl(iconName: BootstrapIcon): string {
  return `https://cdn.jsdelivr.net/npm/bootstrap-icons@1.11.3/icons/${iconName}.svg`
}

// Helper function to convert kebab-case to PascalCase and get icon URL
export function getBootstrapIconUrlByKey(iconKey: string): string {
  const enumKey = iconKey
    .split('-')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join('') as keyof typeof BootstrapIcon

  if (!(enumKey in BootstrapIcon)) {
    throw new Error(`Icon '${iconKey}' (${enumKey}) is not in the pre-approved BootstrapIcon enum`)
  }

  // Get the enum value and return the URL
  const iconEnumValue = BootstrapIcon[enumKey]
  return getBootstrapIconUrl(iconEnumValue)
}
